import { createAction, props } from '@ngrx/store';

import { IListMyOrdersInput, IListMyOrdersResult } from '@shared/models/orders';

export const resetMyOrdersAction = createAction('[MyOrders] Reset');

export const listMyOrdersAction = createAction(
  '[MyOrders] Fetch My Orders',
  props<IListMyOrdersInput>()
);

export const listMyOrdersActionSuccess = createAction(
  '[MyOrders] Fetch My Orders Success',
  props<IListMyOrdersResult>()
);

export const listMyOrdersActionFailure = createAction(
  '[MyOrders] Fetch My Orders Failure'
);
